import { observer } from "mobx-react";
import { SelectDropdown } from "../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { voucherTypeList, VOUCHER_TYPE, VOUCHER_TYPE_MAP } from "../../../../../../constants";
import { RefundTypeProps } from "../refund-type-props";

const VoucherType: React.FC<RefundTypeProps> = observer(({ resolution, validationGroup }) => {
    const selectedVoucherTyoe = VOUCHER_TYPE_MAP[resolution?.voucherType as VOUCHER_TYPE];

    return (
        <SelectDropdown
            value={selectedVoucherTyoe}
            options={voucherTypeList()}
            onChange={(v) => {
                if (v) {
                    resolution?.setVoucherType(v.value as VOUCHER_TYPE);
                }
            }}
            required
            validationGroup={validationGroup} />
    );
});

export default VoucherType;